import React from 'react'
import PropTypes from 'prop-types'
import { withTheme } from 'react-jss'

import confirmationStyles from './confirmation-style'

const Confirmation = props => {
  const classes = confirmationStyles(props.theme)

  return (
    <div className={classes.confirmation}>
      {props.title && <p className={classes.confirmationTitle}>{props.title}</p>}
      {props.text && <p className={classes.confirmationText}>{props.text}</p>}
    </div>
  )
}

Confirmation.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
}

export default withTheme(Confirmation)
